import { formatActivityTimeAgo } from '../lib/activityFeed';

const TYPE_STYLES = {
  swipe_like: 'border-lime/40 bg-lime/40',
  swipe_pass: 'border-hairline bg-panel',
  rating: 'border-streak/40 bg-streak/40',
  match: 'border-mint/40 bg-mint/50',
};

const TYPE_ICON = {
  swipe_like: '👀',
  swipe_pass: '✋',
  rating: '⭐',
  match: '⚡',
};

export default function HouseholdFeed({ items, onRecipeClick }) {
  if (!items?.length) return null;

  return (
    <section>
      <h3 className="font-display text-base lg:text-lg font-semibold text-ink mb-3">
        League feed
      </h3>

      {/* Mobile: horizontal story-style scroll */}
      <div
        className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1 lg:hidden"
        style={{ scrollbarWidth: 'none' }}
      >
        {items.map(item => (
          <FeedCard
            key={item.id}
            item={item}
            onRecipeClick={onRecipeClick}
            compact
          />
        ))}
      </div>

      {/* Desktop: vertical timeline */}
      <ul className="hidden lg:block space-y-2">
        {items.map(item => (
          <li key={item.id}>
            <FeedCard
              item={item}
              onRecipeClick={onRecipeClick}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}

function FeedCard({ item, onRecipeClick, compact }) {
  const style = TYPE_STYLES[item.type] || TYPE_STYLES.swipe_pass;
  const icon = TYPE_ICON[item.type] || '•';
  const clickable = item.recipeId && onRecipeClick;

  const content = (
  <>
      <div className="flex items-start gap-3">
        <div className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-sm font-body font-semibold ${
          item.type === 'match' ? 'bg-mint/10 text-mint' : 'bg-surface text-ink-soft'
        }`}>
          {item.avatar}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            {item.type !== 'match' && (
              <span className="font-body text-sm font-semibold text-ink">{item.memberName}</span>
            )}
          </div>
          <p className="font-body text-sm text-ink-soft leading-snug mt-0.5">{item.message}</p>
          {item.timestamp && (
            <p className="font-body text-[11px] text-ink-muted mt-1">
              {formatActivityTimeAgo(item.timestamp)}
            </p>
          )}
        </div>
        <span className="shrink-0 text-lg opacity-80" aria-hidden="true">{icon}</span>
      </div>
  </>
  );

  if (compact) {
    return (
      <div className={`shrink-0 w-44 rounded-xl border p-3 ${style}`}>
        {content}
      </div>
    );
  }

  if (clickable) {
    return (
      <button
        type="button"
        onClick={() => onRecipeClick(item.recipeId)}
        className={`w-full rounded-xl border p-4 text-left transition-colors hover:bg-surface/80 ${style}`}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={`rounded-xl border p-4 ${style}`}>
      {content}
    </div>
  );
}
